module.exports = "<div class=\"left-menu\" fxLayout=\"row\" fxFlexAlign=\"start stretch\">\r\n    <div fxLayout=\"column\">\r\n        <div class=\"button\" *ngFor=\"let button of listButtons\"\r\n             [routerLink]=\"button.routerLink\"\r\n             [class.choose]=\"button==selectedItem\"\r\n             (click)=\"selectButton(button)\">\r\n            <img src=\"assets/images/{{button.image}} \" />\r\n            <label>{{button.name}}</label>\r\n        </div>\r\n    </div>    \r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/home-page/left-menu/left-menu.component.html
// module id = ./src/app/components/home-page/left-menu/left-menu.component.html
// module chunks = main